'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import Globe from '@/app/components/icons/Globe';

export default function LanguageSwitch() {
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const changeLang = () => {
    const nextLocale = locale === 'en' ? 'ar' : 'en';
    document.cookie = `NEXT_LOCALE=${nextLocale}`;
    const searchParams = window.location.search;
    const newUrl = `/${nextLocale}${pathname.replace(/^\/(en|ar)/, '')}${searchParams}`;
    router.push(newUrl);
  };

  return (
    <button
      onClick={changeLang}
      className={`absolute top-4 flex cursor-pointer flex-col md:top-[56px] ${
        locale === 'en' ? 'right-4 md:right-[56px]' : 'left-4 md:left-[56px]'
      } h-10 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm`}
    >
      <p className="flex items-center gap-2">
        {locale === 'en' ? <span className="mb-2">عربي</span> : 'English'}
        <Globe className="fill-current text-gray-500" />
      </p>
    </button>
  );
}
